export function isError(something) {
    return (typeof something === "object" &&
        !!something &&
        "name" in something &&
        "message" in something);
}
export default isError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNFcnJvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lcnJvcnMvaXNFcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLFVBQVUsT0FBTyxDQUFDLFNBQWtCO0lBQ3hDLE9BQU8sQ0FDTCxPQUFPLFNBQVMsS0FBSyxRQUFRO1FBQzdCLENBQUMsQ0FBQyxTQUFTO1FBQ1gsTUFBTSxJQUFJLFNBQVM7UUFDbkIsU0FBUyxJQUFJLFNBQVMsQ0FDdkIsQ0FBQztBQUNKLENBQUM7QUFFRCxlQUFlLE9BQU8sQ0FBQyJ9